import { tokenManager } from './api';

export interface SystemSettings {
  id: number;
  system_name: string;
  logo: string | null;
  logo_url: string | null;
  company_name: string;
  company_address: string;
  company_phone: string;
  company_email: string;
  updated_at: string;
}

export interface SystemSettingsResponse {
  success: boolean;
  message?: string;
  settings?: SystemSettings;
  errors?: any;
}

class SystemSettingsAPI {
  // Environment variable-dan base URL oxu
  private baseURL = `${process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api'}/system-settings`;

  // Sistem ayarlarını al
  async getSettings(): Promise<SystemSettingsResponse> {
    try {
      const response = await fetch(`${this.baseURL}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('System settings fetch error:', error);
      return {
        success: false,
        message: 'Sistem ayarları alınmadı'
      };
    }
  }

  // Sistem ayarlarını yenilə
  async updateSettings(settings: Partial<SystemSettings>): Promise<SystemSettingsResponse> {
    try {
      const token = tokenManager.getToken();
      if (!token) {
        return {
          success: false,
          message: 'Giriş tələb olunur'
        };
      }

      const response = await fetch(`${this.baseURL}/update/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(settings),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('System settings update error:', error);
      return {
        success: false,
        message: 'Sistem ayarları yenilənmədi'
      };
    }
  }

  // Logo yüklə
  async uploadLogo(logoFile: File): Promise<SystemSettingsResponse> {
    try {
      const token = tokenManager.getToken();
      if (!token) {
        return {
          success: false,
          message: 'Giriş tələb olunur'
        };
      }

      const formData = new FormData();
      formData.append('logo', logoFile);

      const response = await fetch(`${this.baseURL}/upload-logo/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Logo upload error:', error);
      return {
        success: false,
        message: 'Logo yüklənmədi'
      };
    }
  }
}

export const systemSettingsAPI = new SystemSettingsAPI();